<h2 mat-dialog-title>Advanced search</h2>

<mat-dialog-content>
  <form id="form" (submit)="submit($event)">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput type="text" [formField]="filterForm.search" />
      </mat-form-field>
    </p>

    <p style="display: flex; gap: 1em">
      <mat-form-field appearance="outline">
        <mat-label>Sort by</mat-label>
        <mat-select [formField]="filterForm.sort">
          <mat-option value="created">Created</mat-option>
          <mat-option value="modified">Modified</mat-option>
          <mat-option value="published">Published</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" style="flex-basis: 40%">
        <mat-label>Order</mat-label>
        <mat-select [formField]="filterForm.order">
          <mat-option value="asc">Ascending</mat-option>
          <mat-option value="desc">Descending</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p style="display: flex; gap: 1em">
      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <mat-select [formField]="filterForm.dateField">
          <mat-option value="timeframe">Timeframe</mat-option>
          <mat-option value="published">Published</mat-option>
          <mat-option value="created">Created</mat-option>
          <mat-option value="modified">Modified</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>After</mat-label>
        <input matInput [matDatepicker]="fromPicker" [formField]="filterForm.dateFrom" />
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Before</mat-label>
        <input matInput [matDatepicker]="untilPicker" [formField]="filterForm.dateUntil" />
        <mat-datepicker-toggle matIconSuffix [for]="untilPicker"></mat-datepicker-toggle>
        <mat-datepicker #untilPicker></mat-datepicker>
      </mat-form-field>
    </p>

    @if (authService.user()) {
      <p>
        <mat-form-field appearance="outline">
          <mat-label>My role</mat-label>
          <mat-select [formField]="filterForm.role">
            <mat-option value="">Any</mat-option>
            <mat-option value="reader">Reader</mat-option>
            <mat-option value="contributor">Contributor</mat-option>
            <mat-option value="owner">Owner</mat-option>
          </mat-select>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [formField]="filterForm.status">
            <mat-option value="">All</mat-option>
            <mat-option value="public">Public</mat-option>
            <mat-option value="draft">Draft</mat-option>
            <mat-option value="archived">Archived</mat-option>
          </mat-select>
        </mat-form-field>
      </p>
    }

    <p>
      <app-form-control-autocomplete
        label="Project"
        [displayWith]="labelDisplayWith"
        (searchString)="labelSearch.set($event)"
        [resource]="labelResource"
        [formField]="filterForm.label"
      />
    </p>

    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group
        [geometry]="filterForm.geojson().value() || undefined"
        [readonly]="false"
        [height]="'400px'"
        (geometryChange)="onGeoSearch($event)"
      />
    </mat-card>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="form">Search</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
